{
  "name": "m3-lap",
  "seed": 1,
  "track": "ring",
  "fixedDtMs": 16.666666666666668,
  "cars": [{ "id": "player", "spawn": { "x": 860, "y": 360, "angle": 1.5707963267948966 }, "ai": null }],
  "inputs": [{ "frame": 0, "car": 0, "throttle": 1, "steer": 0.5, "handbrake": false }],
  "captures": [
    { "frame": 150, "name": "half" },
    { "frame": 300, "name": "lap1" }
  ]
}
